export default function (myApp) {
    myApp.config(['$stateProvider', require('./exercisesPerCF.js')]);
    myApp.config(['$stateProvider', require('./gtExercisesDistribution.js')]);
    myApp.config(['$stateProvider', require('./exercisesDistribution.js')]);
};



// WEBPACK FOOTER //
// ./js/stats/statsState.js